import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  viewersOvbFeatureSelector,
  ovbViewersMetricsEnabledSelector,
  isCDNAccountSelector,
} from '@store/common/selectors';
import ViewToggle from './ViewToggle';
import { DimensionWidgetWrapper } from './styled';
import DimensionTable from './DimensionTable';
import ViewersTable from './viewerSessions';
import ViewerAccessGate from '@components/common/ViewerAccessGate';
import { Tabs } from './utils';

function DimensionContainer({ config, widgetIndex }) {
  const [tab, setTab] = useState(Tabs.Trends);

  const viewersOvbEnabled = useSelector(viewersOvbFeatureSelector);
  const isCDNAccount = useSelector(isCDNAccountSelector);
  const showViewersTab = useSelector(ovbViewersMetricsEnabledSelector);

  return (
    <DimensionWidgetWrapper>
      {viewersOvbEnabled && showViewersTab && !isCDNAccount && (
        <ViewToggle selectedTab={tab} setTab={setTab} />
      )}
      <DimensionTable show={tab === Tabs.Trends} config={config} widgetIndex={widgetIndex} />
      {/* Top Impacted Viewers is a viewer-level surface (PDF-1524) — gate its content on
          hasViewerAccess, keeping the tab visible with the standard "no permission" message
          inside. The server (requireViewerAccess) is the real enforcement. */}
      {tab === Tabs.Viewers && (
        <ViewerAccessGate>
          <ViewersTable />
        </ViewerAccessGate>
      )}
    </DimensionWidgetWrapper>
  );
}

export default DimensionContainer;
